import { marked, type Token } from 'marked';
import type { ParseResult, ParsedLine } from './types.js';

export function parseMarkdownVocabulary(text: string): ParseResult {
  const cards: ParsedLine[] = [];
  const errors: string[] = [];

  const tokens = marked.lexer(text);
  let lineNumber = 0;

  function visitTokens(tokenList: Token[]): void {
    for (const token of tokenList) {
      if (token.type === 'list') {
        for (const item of token.items) {
          lineNumber += 1;
          const raw = item.text.trim();
          if (!raw) {
            continue;
          }

          // Split by whitespace: 汉字 拼音 组词...
          const parts = raw.split(/\s+/u);
          if (parts.length < 3) {
            errors.push(`第 ${lineNumber} 行格式错误：需要「汉字 拼音 组词」，实际为「${raw}」`);
            continue;
          }

          const [hanzi, pinyin, ...phraseParts] = parts;
          if (!hanzi || !pinyin) {
            errors.push(`第 ${lineNumber} 行缺少汉字或拼音：「${raw}」`);
            continue;
          }

          cards.push({
            hanzi,
            pinyin,
            phrase: phraseParts.join(' '),
            lineNumber,
          });
        }
      } else if ('tokens' in token && Array.isArray((token as { tokens?: unknown }).tokens)) {
        visitTokens((token as { tokens: Token[] }).tokens);
      }
    }
  }

  visitTokens(tokens);
  return { cards, errors };
}
